import { useSidewall } from '../../../../../hooks/state/useSidewall'
import { MarqueeVerticalBox } from './MarqueeVerticalBox'
import { MarqueeRoundBox } from './MarqueeRoundBox'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { MarqueeVerticalWithoutBox } from './MarqueeVerticalWithoutBox'
import { RoundedBox } from '@react-three/drei'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import { useVerandaSelector } from '../../../../..'
import { Keys } from '../../../../../hooks/state/utlility/utils'
import { Helper } from '../../../../../classes/helper'

export const MarqueeVertical = (): JSX.Element => {
  const {
    sideWall,
    hasVerticalMarquee,
    marqueeTyp,
    verticalMarqueeInside,
    checkDefaultVerticalMarquee,
    verticalMarqueeAttr,
    spaceBetweenY,
    verticalMarqueeColor,
    plankHeight,
    sidwallTyp,
    type,
    isWallCenter,
  } = useSidewall()
  const { isQubus, verandaTyp } = useMeasures()
  const { verticalMarqueeMetalColor } = useSidewall()
  const shadingMode = useVerandaSelector((state) => state.scene.shadingMode)
  const inAndOut = shadingMode ? spaceBetweenY - 0.1 : spaceBetweenY / 2
  const rightSide = type === Keys.Seitenwände.Values.SeitenwandRechts.key
  const marqueePostionY =
    (sideWall.hasPlankWall ? plankHeight : 0) +
    spaceBetweenY -
    (sideWall.hasWedge ? 0 : verticalMarqueeAttr.height / 2)

  const postionX =
    verticalMarqueeAttr.position === 'in'
      ? (verticalMarqueeAttr.depth - sidwallTyp.log.depth) / 2
      : verticalMarqueeAttr.position === 'out'
      ? -(verticalMarqueeAttr.depth + sidwallTyp.log.depth) / 2
      : isWallCenter
      ? verandaTyp.log.depth / 2
      : verandaTyp.log.width / 2

  return (
    <group
      position={[rightSide ? -postionX : postionX, marqueePostionY, 0]}
      rotation={[0, Helper.convertAngleToRadiant(rightSide ? 180 : 0), 0]}
    >
      {marqueeTyp.eckig && <MarqueeVerticalBox />}
      {(marqueeTyp.rund || marqueeTyp.default) && (
        <MarqueeRoundBox
          outside={
            checkDefaultVerticalMarquee
              ? verticalMarqueeInside
              : hasVerticalMarquee
          }
          isQubus={isQubus}
        />
      )}
      {marqueeTyp.ohne && <MarqueeVerticalWithoutBox />}

      <group
        position={[
          (verticalMarqueeAttr.depth - sidwallTyp.log.depth) / 2,
          0,
          0,
        ]}
      >
        <group position={[-0.015, 0, 0]}>
          <mesh
            position={[
              0,
              -(inAndOut + verticalMarqueeAttr.height * 0.8) / 2 + 0.01,
              0,
            ]}
          >
            <RoundedBox
              args={[0.0015, inAndOut, verticalMarqueeAttr.width - 0.015]}
              radius={0.00015}
              smoothness={0.5}
              castShadow={true}
              matrixWorldAutoUpdate={undefined}
              getObjectsByProperty={undefined}
              getVertexPosition={undefined}
            >
              <CachedMeshPhysicalMaterial
                color={verticalMarqueeColor}
                roughness={0.8}
                metalness={0.1}
              />
            </RoundedBox>
          </mesh>
          <mesh
            castShadow={true}
            rotation={[0, 0, 0]}
            position={[0, -inAndOut - 0.01, 0]}
            receiveShadow={true}
          >
            <RoundedBox
              args={[0.003, 0.05, verticalMarqueeAttr.width - 0.015]}
              radius={0.00015}
              smoothness={0.5}
              castShadow={true}
              matrixWorldAutoUpdate={undefined}
              getObjectsByProperty={undefined}
              getVertexPosition={undefined}
            >
              <CachedMeshPhysicalMaterial color={verticalMarqueeMetalColor} />
            </RoundedBox>
          </mesh>
        </group>

        {[...Array(2)].map((_, index) => {
          return (
            <mesh
              castShadow={true}
              rotation={[0, 0, 0]}
              key={`SideTieVerticalMarquee${index}`}
              position={[
                0,
                -spaceBetweenY / 2,
                -verticalMarqueeAttr.width / 2 +
                  verticalMarqueeAttr.width * index,
              ]}
              receiveShadow={true}
            >
              <boxGeometry
                args={[
                  sidwallTyp.log.depth,
                  spaceBetweenY - verticalMarqueeAttr.height,
                  0.015,
                ]}
              />
              <CachedMeshPhysicalMaterial color={verticalMarqueeMetalColor} />
            </mesh>
          )
        })}
      </group>
    </group>
  )
}
